import { instance } from "../instance";

/**
 * Get Incident using incident ID
 * @param id
 * @returns
 */
export const getIncident = async (id: string) => {
  return instance({
    method: "get",
    url: `/incidentId?incidentId=${id}`,
  });
};

/**
 * Get Dashboard Report figures
 * @param contactId
 * @param filterDays
 * @param facility
 * @returns {}
 */
export const getDashboardReport = async (
  contactId: string,
  filterDays: number,
  facility: string
) => {
  let url: string = `/dashboard/?userId=${contactId}`;
  if (facility) url += `&facilityId=${facility}`;
  if (filterDays > 0) url += `&filterInDays=${filterDays}`;
  return instance({
    method: "get",
    url,
  });
};

/**
 * Get Incident Logs using incidentId
 * @param incidentId
 * @returns {}
 */
export const getIncidentLogs = async (incidentId: string) => {
  return instance({
    method: "get",
    url: `/log?incidentId=${incidentId}`,
  });
};
